
import Vue from 'vue'
import { QInput, QSelect, QBanner } from 'quasar'
import gql from 'graphql-tag';
import { apolloState } from '@/main'

export default Vue.extend({
    components: { QInput, QSelect, QBanner },
    data() {
        return {
            list: <any>{},
            isLoading: false,
            lists: [],
            error: false,
            password: ''
        }
    },
    apollo: {
        lists: gql`
            query lists {
                lists {
                id
                name
                }
            }
        `,
    },
    computed: {
        apolloError() {
            return apolloState.wsError
        },
        isRecentFirefox() {
            const m = navigator.userAgent.match(/Firefox\/([0-9]+)\./i)
            if(!m) return false
            return parseInt(m[1]) >= 68 // min version

        }
    },
    methods: {
        async submit() {
            if(this.isLoading) return
            this.isLoading = true
            this.error = false
            try {
                const res = await this.$apollo.mutate({
                    mutation: gql`
                        mutation login ($listId: String!, $password: String!) {
                            login(password: $password, id: $listId) {
                                id,
                                name
                            }
                        }
                    `,
                    variables: {
                        listId: this.list.id,
                        password: this.password
                    }
                })
                this.$router.push({
                    name: 'list'
                })
                apolloState.reconnect()
            } catch(err) {
                if(err.graphQLErrors && err.graphQLErrors.length) {
                    this.error = err.graphQLErrors[0].message
                } else {
                    this.error = err.message
                }
                this.isLoading = false
            }
        }
    }
})
